import * as React from "react"

export type ThemePreference = "light" | "dark" | "system"
const STORAGE_KEY = "contracting-os-theme"

function resolvedTheme(preference: ThemePreference) {
  if (preference !== "system") return preference
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"
}

function applyTheme(preference: ThemePreference) {
  document.documentElement.classList.toggle("dark", resolvedTheme(preference) === "dark")
  document.documentElement.style.colorScheme = resolvedTheme(preference)
}

export function useTheme() {
  const [theme, setThemeState] = React.useState<ThemePreference>("system")

  React.useEffect(() => {
    const stored = window.localStorage.getItem(STORAGE_KEY) as ThemePreference | null
    const preference = stored === "light" || stored === "dark" || stored === "system" ? stored : "system"
    setThemeState(preference)
    applyTheme(preference)
    const media = window.matchMedia("(prefers-color-scheme: dark)")
    const onChange = () => preference === "system" && applyTheme("system")
    media.addEventListener("change", onChange)
    return () => media.removeEventListener("change", onChange)
  }, [])

  const setTheme = React.useCallback((preference: ThemePreference) => {
    setThemeState(preference)
    window.localStorage.setItem(STORAGE_KEY, preference)
    applyTheme(preference)
  }, [])

  return { theme, setTheme }
}
